export default "<div class=”page”>\r\n  <router-outlet></router-outlet>\r\n</div>\r\n";